var map = {
	"./views/ai-moudle/components/config-dialog.vue": 10077,
	"./views/ai-moudle/components/prompt-dialog.vue": 42704,
	"./views/ai-moudle/config.vue": 32178,
	"./views/ai-moudle/configuration.vue": 92982,
	"./views/ai-moudle/prompt.vue": 92245,
	"./views/dashboard/dashboard.vue": 944,
	"./views/error-page/401.vue": 85296,
	"./views/error-page/404.vue": 76690,
	"./views/login/components/accout-action.vue": 78278,
	"./views/login/components/panel-company.vue": 37022,
	"./views/login/components/phone-action.vue": 1851,
	"./views/login/login.vue": 31938,
	"./views/sever/message_list/index.vue": 84915,
	"./views/sever/postoperativecare.vue": 64474,
	"./views/sever/projects/components/left-user.vue": 28728,
	"./views/sever/projects/components/right-chat.vue": 196,
	"./views/sever/projects/index.vue": 21038,
	"./views/sever/screen_mg.vue": 41210,
	"./views/system/action.vue": 6256,
	"./views/system/admin.vue": 26336,
	"./views/system/components/admin-dialog.vue": 42524,
	"./views/system/components/permission-dialog.vue": 495,
	"./views/system/components/role-dialog.vue": 62567,
	"./views/system/log.vue": 8252,
	"./views/system/permission.vue": 52758,
	"./views/system/role.vue": 91281
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 10090;